<template>
  <div
    v-if="hasProviderSelection"
    class="
      d-flex
      s-p-3 s-border-b s-border-gray-light
      bg-white
      justify-content-between
      align-items-center
    "
  >
    <select
      class="form-control"
      v-model="selectedOption"
      @change="onProviderChange"
    >
      <option
        v-for="option in providerSelectOptions"
        :key="option.key || option.provider"
        :value="option"
      >
        {{ option.title }}
      </option>
    </select>
  </div>
</template>

<script>
const MODULE_CODE = 'liff_coupon'

export default {
  name: 'ProviderSelector',

  data() {
    return {
      selectedOption: null,
    }
  },

  computed: {
    hasProviderSelection() {
      return this.getModuleConfig('provider_select.enable') &&
        this.getModuleConfig('provider_select.options') &&
        this.getModuleConfig('provider_select.options').length > 0
    },

    providerSelectOptions() {
      if (!this.hasProviderSelection) return []
      return this.getModuleConfig('provider_select.options')
    }
  },

  mounted() {
    this.initializeProvider()
  },

  methods: {
    initializeProvider() {
      if (!this.hasProviderSelection) {
        return;
      }

      if (this.$route.query.key) {
        const option = this.providerSelectOptions.find(opt => opt.key === this.$route.query.key)
        if (option) {
          this.selectedOption = option
        }
      } else {
        this.selectedOption = this.providerSelectOptions[0]
      }

      // 初始化後觸發 provider-changed 事件
      this.$nextTick(() => {
        this.$emit('provider-changed', this.getParams())
      })
    },

    onProviderChange() {
      // Update URL with key parameter
      const currentQuery = { ...this.$route.query }
      if (this.selectedOption.key) {
        currentQuery.key = this.selectedOption.key
      } else {
        delete currentQuery.key
      }

      this.$router.push({
        query: { ...currentQuery}
      }).finally(() => {
        this.$emit('provider-changed', this.getParams())
      })
    },

    getParams() {
      if (!this.hasProviderSelection || !this.selectedOption) {
        return {}
      }

      const params = {
        provider: this.selectedOption.provider
      }

      if (this.selectedOption.key) {
        params.key = this.selectedOption.key
      }

      return params
    },

    getModuleConfig(key) {
      return this.$store.getters["liffModule/getConfig"](MODULE_CODE, key);
    },
  }
}
</script>

<style lang="scss" scoped>
select {
  border: 1px solid var(--s-gray-dark);
  border-radius: 0.5rem;
  padding: 0 1rem;
}
</style>
